import { splitNavThreadsByPinned } from './splitNavThreadsByPinned.js'

/**
 * Split nav threads into the two sidebar thread sections.
 *
 * Scheduled used to be a third bucket carved out of these, which meant a chat
 * *left* the Chats list the moment it gained a schedule. Scheduled now lists
 * workflows rather than chats, so every chat stays here and its schedule shows
 * as a clock badge instead — see `selectScheduledThreadIds`.
 *
 * @template {{ id: string }} T
 * @param {T[]} threads
 * @param {string[]} pinnedThreadIds
 * @returns {{ pinnedThreads: T[]; chatThreads: T[] }}
 */
export function splitNavThreadGroups(threads = [], pinnedThreadIds = []) {
  const { pinnedThreads, unpinnedThreads } = splitNavThreadsByPinned(threads, pinnedThreadIds)
  return { pinnedThreads, chatThreads: unpinnedThreads }
}
